const batchesTranslations = {
  en: {
    pageTitle: "Batches",
    intro:
      "At Akaal Kids, batches are thoughtfully designed to support spiritual growth, focused learning, and personal attention. Each batch follows a structured Gurmat-based approach while remaining flexible for students across different countries and time zones.",
    admission:
      "Admission into batches is level-based, not age-based, allowing every learner to progress at a comfortable and confident pace.",
    ageGroupHeading: "Age Group Focus",
    ageGroupIntro:
      "Akaal Kids welcomes learners from 5 years onwards. These early years play a crucial role in shaping a child’s values, discipline, and spiritual foundation.",
    developHeading: "Our batches help learners develop:",
    developPoints: [
      "Bibek Budhi (spiritual wisdom)",
      "Self-discipline and focus",
      "Clear Sikh identity",
      "Moral strength and confidence",
    ],
    youthNote:
      "Youth and adults are also welcome and are placed in appropriate batches according to their learning level.",
    levelsHeading: "Batch Levels",
    levels: [
      {
        title: "Level 1 – Foundation Batch",
        desc: "Designed for beginners starting their Gurmat journey.",
        focus: [
          "Basic Punjabi reading",
          "Correct pronunciation of Gurbani",
          "Learning values through stories (Khed Khed Vich)",
          "Memorization of Japji Sahib",
          "Sunehre Panne (handwritten Gurbani practice)",
        ],
      },
      {
        title: "Level 2 – Understanding Batch",
        desc: "For learners ready to deepen comprehension and fluency.",
        focus: [
          "Complete Nitnem reading with meaning",
          "Improvement of pronunciation and rhythm",
          "Introduction to Gurbani grammar",
          "Memorization and structured revision",
          "Sunehre Panne with complete Japji Sahib",
        ],
      },
      {
        title: "Level 3 – Depth Batch",
        desc: "For learners seeking advanced engagement with Gurbani.",
        focus: [
          "Advanced Gurbani Santhya",
          "Complete Nitnem memorization",
          "High accuracy in pronunciation",
          "Values-based discussions",
          "Sunehre Panne with complete Nitnem",
        ],
      },
      {
        title: "Level 4 – Mastery Batch",
        desc: "For learners committed to long-term Gurmat learning.",
        focus: [
          "Complete Sri Guru Granth Sahib Ji Paath",
          "Deep understanding of Arth",
          "Applying Gurbani in daily life",
          "Spiritual discipline and reflection",
          "Continued writing and memorization practice",
        ],
      },
    ],
    structureHeading: "Batch Structure",
    structurePoints: [
      "Each batch is conducted in small, focused groups to ensure:",
      "Individual attention",
      "Comfortable interaction",
      "Clear guidance and correction",
      "Respectful teacher–student connection",
      "All classes are conducted in a calm, disciplined, and Gurmat-centered environment.",
    ],
    optionalHeading: "Optional Enrichment Batches",
    optionalIntro: "For interested learners, additional batches are available:",
    optionalPoints: [
      "Kirtan (Vocal training)",
      "Tabla",
      "Gurmat-based expression and acting",
      "These batches encourage confidence, creativity, and deeper connection with Sikhi.",
    ],
    globalHeading: "Global Learning Community",
    globalIntro: "Akaal Kids welcomes students from:",
    countries: ["USA", "Canada", "UK", "Australia", "India", "And worldwide"],
    globalNote:
      "Batch timings are adjusted according to the learner’s country and time zone to ensure comfort and consistency.",
    placementHeading: "Batch Placement Process",
    placementPoints: [
      "Before joining a batch:",
      "Each learner’s reading and understanding level is assessed",
      "Parents receive clear guidance",
      "Placement is done to ensure steady and stress-free progress",
    ],
  },
  pa: {
    pageTitle: "ਬੈਚਾਂ ਬਾਰੇ",
    intro:
      "ਅਕਾਲ ਕਿਡਜ਼ ਵਿੱਚ ਬੈਚ ਇਸ ਤਰ੍ਹਾਂ ਤਿਆਰ ਕੀਤੇ ਗਏ ਹਨ ਕਿ ਹਰ ਵਿਦਿਆਰਥੀ ਨੂੰ ਆਤਮਿਕ ਵਿਕਾਸ, ਧਿਆਨ ਅਤੇ ਸਮਝ ਨਾਲ ਸਿੱਖਣ ਦਾ ਮੌਕਾ ਮਿਲੇ। ਸਾਰੇ ਬੈਚ ਗੁਰਮਤਿ ਅਧਾਰਿਤ ਸਿੱਖਿਆ ਪ੍ਰਣਾਲੀ ਅਨੁਸਾਰ ਚਲਾਏ ਜਾਂਦੇ ਹਨ ਅਤੇ ਵੱਖ-ਵੱਖ ਦੇਸ਼ਾਂ ਵਿੱਚ ਰਹਿੰਦੇ ਵਿਦਿਆਰਥੀਆਂ ਲਈ ਅਨੁਕੂਲ ਹਨ।",
    admission: "ਅਕਾਲ ਕਿਡਜ਼ ਵਿੱਚ ਦਾਖਲਾ ਉਮਰ ਨਹੀਂ, ਸਿੱਖਣ ਦੇ ਪੱਧਰ ਅਨੁਸਾਰ ਹੁੰਦਾ ਹੈ।",
    ageGroupHeading: "ਉਮਰ ਅਨੁਸਾਰ ਧਿਆਨ",
    ageGroupIntro:
      "ਅਕਾਲ ਕਿਡਜ਼ 5 ਸਾਲ ਦੀ ਉਮਰ ਤੋਂ ਸਿੱਖਣ ਵਾਲਿਆਂ ਲਈ ਖੁੱਲ੍ਹਾ ਹੈ। ਇਹ ਉਮਰ ਬੱਚਿਆਂ ਵਿੱਚ: ਬਿਬੇਕ ਬੁੱਧੀ, ਅਨੁਸ਼ਾਸਨ, ਸਿੱਖੀ ਨਾਲ ਪਛਾਣ, ਨੈਤਿਕ ਮਜ਼ਬੂਤੀ ਵਿਕਸਤ ਕਰਨ ਲਈ ਬਹੁਤ ਮਹੱਤਵਪੂਰਨ ਹੁੰਦੀ ਹੈ।",
    developHeading: "ਸਾਡੀਆਂ ਬੈਚਾਂ ਵਿਦਿਆਰਥੀਆਂ ਵਿੱਚ ਵਿਕਸਤ ਕਰਦੀਆਂ ਹਨ:",
    developPoints: [
      "ਬਿਬੇਕ ਬੁੱਧੀ",
      "ਅਨੁਸ਼ਾਸਨ",
      "ਸਿੱਖੀ ਨਾਲ ਪਛਾਣ",
      "ਨੈਤਿਕ ਮਜ਼ਬੂਤੀ",
    ],
    youthNote:
      "ਨੌਜਵਾਨ ਅਤੇ ਬਾਲਗ ਵੀ ਆਪਣੀ ਸਮਝ ਅਨੁਸਾਰ ਬੈਚਾਂ ਵਿੱਚ ਸ਼ਾਮਲ ਕੀਤੇ ਜਾਂਦੇ ਹਨ।",
    levelsHeading: "ਬੈਚਾਂ ਦੇ ਪੱਧਰ",
    levels: [
      {
        title: "ਲੈਵਲ 1 – ਮੂਲ ਬੈਚ",
        desc: "ਇਹ ਬੈਚ ਗੁਰਮਤਿ ਸਿੱਖਿਆ ਦੀ ਸ਼ੁਰੂਆਤ ਕਰਨ ਵਾਲਿਆਂ ਲਈ ਹੈ।",
        focus: [
          "ਮੂਲ ਪੰਜਾਬੀ ਪੜ੍ਹਾਈ",
          "ਗੁਰਬਾਣੀ ਦਾ ਸਹੀ ਉਚਾਰਣ",
          "ਖੇਡ ਖੇਡ ਵਿੱਚ ਸਿੱਖਿਆ",
          "ਜਪੁਜੀ ਸਾਹਿਬ ਕੰਠ",
          "ਸੁਨਹਿਰੀ ਪੰਨੇ (ਗੁਰਬਾਣੀ ਲਿਖਤ)",
        ],
      },
      {
        title: "ਲੈਵਲ 2 – ਸਮਝ ਬੈਚ",
        desc: "ਇਹ ਬੈਚ ਸਮਝ ਵਧਾਉਣ ਲਈ ਹੈ।",
        focus: [
          "ਗੁਰਬਾਣੀ ਉਚਾਰਣ",
          "ਅਰਥ ਸਮੇਤ ਨਿਤਨੇਮ ਪਾਠ",
          "ਗੁਰਬਾਣੀ ਵਿਆਕਰਨ ਦੀ ਜਾਣਕਾਰੀ",
          "ਯਾਦ ਅਤੇ ਦੁਹਰਾਈ",
          "ਸੁਨਹਿਰੀ ਪੰਨੇ (ਪੂਰਾ ਜਪੁਜੀ ਸਾਹਿਬ)",
        ],
      },
      {
        title: "ਲੈਵਲ 3 – ਗਹਿਰਾਈ ਬੈਚ",
        desc: "ਇਹ ਬੈਚ ਗੁਰਬਾਣੀ ਨਾਲ ਡੂੰਘੀ ਰੁਚੀ ਵਾਲਿਆਂ ਲਈ ਹੈ।",
        focus: [
          "ਉੱਚ ਪੱਧਰੀ ਗੁਰਬਾਣੀ ਸੰਥਿਆ",
          "ਪੂਰਾ ਨਿਤਨੇਮ ਕੰਠ",
          "ਸਹੀ ਉਚਾਰਣ",
          "ਗੁਰਮਤਿ ਵਿਚਾਰ",
          "ਸੁਨਹਿਰੀ ਪੰਨੇ (ਪੂਰਾ ਨਿਤਨੇਮ)",
        ],
      },
      {
        title: "ਲੈਵਲ 4 – ਨਿਪੁੰਨਤਾ ਬੈਚ",
        desc: "ਇਹ ਉੱਚ ਪੱਧਰੀ ਬੈਚ ਗੰਭੀਰ ਗੁਰਮਤਿ ਅਭਿਆਸ ਲਈ ਹੈ।",
        focus: [
          "ਸ੍ਰੀ ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਜੀ ਦਾ ਪੂਰਾ ਪਾਠ",
          "ਅਰਥ ਦੀ ਡੂੰਘੀ ਸਮਝ",
          "ਗੁਰਬਾਣੀ ਨੂੰ ਜੀਵਨ ਵਿੱਚ ਅਪਣਾਉਣਾ",
          "ਆਤਮਿਕ ਅਨੁਸ਼ਾਸਨ",
          "ਲਗਾਤਾਰ ਲਿਖਤ ਅਤੇ ਯਾਦ",
        ],
      },
    ],
    structureHeading: "ਬੈਚਾਂ ਦੀ ਬਣਤਰ",
    structurePoints: [
      "ਹਰ ਬੈਚ ਛੋਟੇ ਗਰੁੱਪਾਂ ਵਿੱਚ ਚਲਾਇਆ ਜਾਂਦਾ ਹੈ",
      "ਵਿਦਿਆਰਥੀ ‘ਤੇ ਵਿਅਕਤੀਗਤ ਧਿਆਨ",
      "ਸ਼ਾਂਤ ਅਤੇ ਸਤਿਕਾਰਪੂਰਕ ਮਾਹੌਲ",
      "ਵਿਕਲਪਕ ਬੈਚ",
      "ਰੁਚੀ ਰੱਖਣ ਵਾਲਿਆਂ ਲਈ: ਕੀਰਤਨ, ਤਬਲਾ, ਗੁਰਮਤਿ ਅਧਾਰਿਤ ਅਭਿਨੈ",
      "ਵਿਸ਼ਵ ਪੱਧਰੀ ਸਿੱਖਿਆ",
      "ਅਮਰੀਕਾ, ਕੈਨੇਡਾ, ਯੂਕੇ, ਆਸਟ੍ਰੇਲੀਆ, ਭਾਰਤ, ਹੋਰ ਦੇਸ਼ਾਂ ਤੋਂ ਵਿਦਿਆਰਥੀ",
      "ਕਲਾਸਾਂ ਦਾ ਸਮਾਂ ਵਿਦਿਆਰਥੀ ਦੇ ਦੇਸ਼ ਅਤੇ ਸਮੇਂ ਅਨੁਸਾਰ",
    ],
    optionalHeading: "ਵਿਕਲਪਕ ਬੈਚ",
    optionalIntro: "ਰੁਚੀ ਰੱਖਣ ਵਾਲਿਆਂ ਲਈ: ਕੀਰਤਨ, ਤਬਲਾ, ਗੁਰਮਤਿ ਅਧਾਰਿਤ ਅਭਿਨੈ",
    optionalPoints: [
      "ਕੀਰਤਨ",
      "ਤਬਲਾ",
      "ਗੁਰਮਤਿ ਅਧਾਰਿਤ ਅਭਿਨੈ",
      "ਆਤਮ-ਵਿਕਾਸ, ਸਿਰਜਣਾਤਮਕਤਾ, ਸਿੱਖੀ ਨਾਲ ਡੂੰਘੀ ਜੋੜ",
    ],
    globalHeading: "ਵਿਸ਼ਵ ਪੱਧਰੀ ਸਿੱਖਿਆ",
    globalIntro: "ਅਕਾਲ ਕਿਡਜ਼ ਵਿੱਚ ਵਿਦਿਆਰਥੀ:",
    countries: ["ਅਮਰੀਕਾ", "ਕੈਨੇਡਾ", "ਯੂਕੇ", "ਆਸਟ੍ਰੇਲੀਆ", "ਭਾਰਤ", "ਹੋਰ ਦੇਸ਼"],
    globalNote:
      "ਕਲਾਸਾਂ ਦਾ ਸਮਾਂ ਵਿਦਿਆਰਥੀ ਦੇ ਦੇਸ਼ ਅਤੇ ਸਮੇਂ ਅਨੁਸਾਰ ਰੱਖਿਆ ਜਾਂਦਾ ਹੈ।",
    placementHeading: "ਬੈਚ ਚੋਣ ਪ੍ਰਕਿਰਿਆ",
    placementPoints: [
      "ਬੈਚ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ:",
      "ਵਿਦਿਆਰਥੀ ਦੀ ਪੜ੍ਹਾਈ ਅਤੇ ਸਮਝ ਦੀ ਜਾਂਚ",
      "ਮਾਤਾ-ਪਿਤਾ ਨੂੰ ਪੂਰੀ ਜਾਣਕਾਰੀ",
      "ਯੋਗਤਾ ਅਨੁਸਾਰ ਸਹੀ ਬੈਚ ਵਿੱਚ ਸ਼ਾਮਿਲ ਕੀਤਾ ਜਾਵੇਗਾ।",
    ],
  },
};

export default batchesTranslations;
